import { render, staticRenderFns } from "./RetrieveOldEmailConfirmation.vue?vue&type=template&id=557bb3a6&"
import script from "./RetrieveOldEmailConfirmation.vue?vue&type=script&lang=ts&"
export * from "./RetrieveOldEmailConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports